var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmacogenomics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.998 13.7168L93.5007 25.554C105.926 32.7279 110.184 48.6165 103.01 61.0421L78.657 103.222C71.8013 115.097 56.6175 119.165 44.743 112.309C32.8686 105.454 28.8001 90.2699 35.6558 78.3954L72.998 13.7168Z",
    fill: "#306153"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_965_35011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.998 13.7168L93.5007 25.554C105.926 32.7279 110.184 48.6165 103.01 61.0421L78.657 103.222C71.8013 115.097 56.6175 119.165 44.743 112.309C32.8686 105.454 28.8001 90.2699 35.6558 78.3954L72.998 13.7168Z",
    fill: "#284993"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_965_35011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.0922,
    height: 49.0922,
    fill: "white",
    transform: "translate(48.0645 57.2734) rotate(30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacogenomics);
export default __webpack_public_path__ + "static/media/Pharmacogenomics.41eacd6900c285a3d88262f1dbe0e477.svg";
export { ForwardRef as ReactComponent };